module.exports = __webpack_public_path__ + "img/Icon-Search-grey.478fbd5b.svg";